import * as React from 'react';
import classNames from 'classnames';
import style from './currency.scss';
import {truncateValue} from './utilities';

export type Currencies = 'USD' | 'CAD';
export type CurrencyDisplayType = 'regular' | 'bold' | 'h3' | 'subhead' | 'big' | 'bigger' | null;

type DivElementProps = JSX.IntrinsicElements['div'];

export interface CurrencyProps extends DivElementProps {
  value: number;
  symbol?: string;
  inline?: boolean;
  emphasis?: boolean;
  condensed?: boolean;
  currency?: Currencies;
  showDecimal?: boolean;
  showCurrency?: boolean;
  display?: CurrencyDisplayType;
  wrapperComponent?: string | React.ComponentClass;
}

const CURRENCY_SYMBOL_MAP = {
  USD: '$',
  CAD: '$',
};

const DEFAULT_CURRENCY = 'USD';

function translateValue(amount: number, showDecimal, condensed = false) {
  if (condensed) {
    return truncateValue(amount);
  }

  return amount.toLocaleString('en-US', {
    maximumFractionDigits: showDecimal ? 2 : 0,
    minimumFractionDigits: showDecimal ? 2 : 0,
  });
}

export function Currency({
  value = 0,
  inline = false,
  style: propsStyle = {},
  symbol,
  emphasis = false,
  condensed = false,
  currency = DEFAULT_CURRENCY,
  className = '',
  showDecimal = false,
  display = 'regular',
  showCurrency = false,
  wrapperComponent = 'div',
  ...restProps
}: CurrencyProps) {
  const Wrapper = wrapperComponent;
  return (
    <Wrapper
      style={propsStyle}
      className={classNames(className, style.container, display && style[display], {
        [style.inline]: inline,
        [style.emphasis]: emphasis,
      })}
      {...restProps}
    >
      <span className={style.currencySymbol}>{symbol || CURRENCY_SYMBOL_MAP[currency]}</span>
      <span className={style.value}>{translateValue(value, showDecimal, condensed)}</span>
      {showCurrency && <span className={style.currency}>{currency}</span>}
    </Wrapper>
  );
}

export default Currency;
